import styled from "styled-components";

import Background from '../../../../assets/images/background/map-1-1.png';
import Background2 from '../../../../assets/images/background/map-1-2.png';

export const BaseComp = styled.div`
    display: flex;
    height: 100%;

`;

export const BaseContent = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    @media only screen and (max-width: 1000px) {
        flex-direction: column;
    }
`;

export const TextContent = styled.div`
    color: var(--purple-dark);
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2% 5%;
    @media only screen and (max-width: 800px) {
        width: 100%;
    }
    .operation {
        text-align: center;
        margin-top: 1%;
        h1 {
            font-size: 30px;
            text-transform: uppercase;
            color: #4b5259;
            font-family: "Montserrat", Sans-serif;
        }
        h2 {
            font-size: 39px;
            @media only screen and (max-width: 800px) {
            font-size: 30px;
        }
        }
        @media only screen and (max-width: 800px) {
            margin: 3% 0 3% 0 ;
        }
    }
`;

export const TextTitle = styled.div`
    text-align: left;
    text-transform: uppercase;
    color: #4b5259;

    h1 {
        font-size: 39px;
        text-transform: uppercase;
        color: var(--setra-blue);
        font-family: "Montserrat";
        @media only screen and (max-width: 800px) {
            font-size: 30px;
        }
    }

    @media only screen and (max-width: 800px) {
        margin: 3% 0 2% 0 ;
    }
`;

export const PrincipalDiv = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    height: auto;
    h2 {
        font-size: 39px;
        color: var(--setra-blue);
    }
    h1 {
        font-size: 30px;
    }
        @media only screen and (max-width: 800px) {
            flex-direction: column;
            h2 {
            font-size: 30px;
        }
    }
    .rede {
        h1 {
            font-size: 25px;
            color: var(--setra-blue);
        }
    }
`;

export const Partners = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    margin: 1%;
`;

export const SocialMedia = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    margin: 1%;
    /* .socialIcon {
        width: 20%;
        height: auto;
        @media only screen and (max-width: 800px) {
            width: 10%;
            height: auto;
        }
        margin: 1%;
    } */
`;

export const TextBody = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 26px;
    text-align: left;
    padding: 10px;
    max-width: 1300px;
    .parceiro {
        color: var(--setra-blue);
    }

    .redes {
        color: var(--setra-blue);
    }
    p {
        margin-top: 1%;
        color: var(--setra-blue);
        font-family: "Montserrat", Sans-serif;
    }
    @media only screen and (max-width: 800px) {
        justify-content: left;
        display: flex;
        flex-direction: column;
        align-items: left;
    }
`;

export const Frota = styled.div`
    margin: 1%;
    padding: 1%;
    display: flex;
    .operation {
        h2 {
            color: white;
            margin: 1%;
        }
        
    }
    color: white;
    flex-direction: column;
    background-color: var(--soft-setra-blue);
`;

export const FrotaContent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    @media only screen and (max-width: 1000px) {
        flex-direction: column;
    }
`;

export const ImageContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row;
    @media only screen and (max-width: 800px) {
        width: 100%;
        margin-top: 10%;
        flex-direction: column;
    }

    .image {
        width: 210px;
        height: auto;
    }

    .swiper-pagination-bullets {
        margin-top: 5%;
    }
`;

export const DefaultBox = styled.div`
    justify-content: center;
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    h4 {
        color: var(--purple);
        margin: 5px 0px;
    }
`;

export const Img = styled.img`
    width: 40%;
    height: auto;
    @media only screen and (max-width: 800px) {
        width: 90%;
        height: auto;
    }
    margin: 1%;
`;

export const ImageBox = styled.div`
    display: flex;
    flex-direction: row;
    max-width: 1300px;
    align-items: center;
    justify-content: center;
    margin: 2%;
`;

export const OurMission = styled.div`
    background-image: url(${Background});
    background-size: cover; /* Ajusta o tamanho da imagem para que ela fique inteira */
    background-repeat: no-repeat; /* Impede que a imagem seja repetida */
    border-radius: 16px;
    @media only screen and (max-width: 800px) {
        background-image: url(${Background2});
        background-size: cover; /* Ajusta o tamanho da imagem para que ela fique inteira */
        background-repeat: no-repeat;
    }

`;

export const AboutUs = styled.div`
`;


export const SidebySideContent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    @media only screen and (max-width: 800px) {
        flex-direction: column;
    }
`;

export const ContactConsultant = styled.div`
    background-color: #F7A816;
    border-radius: 20px;
    justify-content: center;
    cursor: pointer;
    max-width: 180px;
    display: flex;
    padding: 2px 5px;
    p {
        font-size: 16px;
    }
    margin-top: 20px;
    align-items: center;
`;

export const MiddleContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1%;
    h1 {
        font-size: 24px;
        text-transform: uppercase;
        color: white;
        font-family: "Montserrat", Sans-serif;
        font-weight: bold;
        @media only screen and (max-width: 1000px) {
            font-size: 20px;
        }
    }
    h2 {
        font-size: 16px;
        color: white;
        font-family: "Montserrat", Sans-serif;
        font-weight: normal;
        font-weight: bold;
        @media only screen and (max-width: 1000px) {
            font-size: 14px;
        }
    }

    .icons {
        margin-top: 1%;
        width: auto;
        height: 100px;
        @media only screen and (max-width: 1000px) {
            height: 70px;
        }
    }

`;

export const IconImg = styled.img`
    width: 40%;
    height: auto;
    @media only screen and (max-width: 500px) {
        width: 35%;
        height: auto;
    }
    
    margin: 1%;
`;

export const SocialImg = styled.img`
    width: 30%;
    height: auto;
    @media only screen and (max-width: 800px) {
        width: 35%;
        height: auto;
    }
    margin: 1%;
`;

export const StyledLink = styled.a`
    display: contents;
`;
